import { render, staticRenderFns } from "./loadstyle.vue?vue&type=template&id=5b0ac352&"
import script from "./loadstyle.vue?vue&type=script&lang=js&"
export * from "./loadstyle.vue?vue&type=script&lang=js&"
import style0 from "./loadstyle.vue?vue&type=style&index=0&id=5b0ac352&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports